import { ACTION_CLICK_CARD_LINK } from 'utils/analytics/eventTypeConstantsAmplitude';
import { BaseWidgetProps } from 'consumer-page-widgets/WidgetUtils/BaseWidgetProps';
import { ValidForRowLayoutWidgetProps } from 'consumer-page-widgets/RowLayoutWidget/RowLayoutWidget';
import { consumer } from '@tock/coretypes';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';
import { wrapWithWidgetContainer } from 'consumer-page-widgets/WidgetUtils/widgetDisplayUtils';
import CardLink, { CardLinkVariant } from 'consumer-page-widgets/CardLinkWidget/CardLink';
import React from 'react';

interface CardLinkWidgetProps extends BaseWidgetProps, ValidForRowLayoutWidgetProps {
  widget: consumer.ICardLinkWidget;
}

function getVariantFromCardLinkVariant(
  variant?: consumer.CardLinkWidget.CardLinkVariant
): CardLinkVariant | undefined {
  if (!variant) {
    return undefined;
  }
  switch (variant) {
    case 'DEFAULT':
      return 'default';
    case 'LARGE':
      return 'large';
  }
}

const CardLinkWidget: React.FunctionComponent<CardLinkWidgetProps> = ({
  widget,
  standalone = true,
  pageWidgetListIndex,
}) => {
  const amplitudeSendEvent = useAmplitudeSendEvent();
  const variant = getVariantFromCardLinkVariant(widget.variant ?? undefined);

  const onClick = () => {
    amplitudeSendEvent(ACTION_CLICK_CARD_LINK, {
      pageWidgetListIndex,
      title: widget.tagline ?? undefined,
      widgetType: 'Collection card link widget',
      destinationHref: widget.linkHref ?? undefined,
    });
  };

  const cardLink = (
    <CardLink
      mainText={widget.tagline ?? ''}
      imageUrl={widget.imageUrl ?? ''}
      imageAltText={widget.imageAlt ?? ''}
      linkText={widget.linkText ?? ''}
      href={widget.linkHref ?? ''}
      variant={variant}
      onClick={onClick}
    />
  );

  return standalone ? wrapWithWidgetContainer(cardLink) : cardLink;
};

export default CardLinkWidget;
